import { QrCode } from "lucide-react";
import { Link } from "react-router-dom";

export function BrandMark({ size = "md" }) {
  const dims = size === "sm" ? "w-9 h-9" : size === "lg" ? "w-12 h-12" : "w-10 h-10";
  return (
    <div className={`${dims} rounded-xl bg-brand flex items-center justify-center shadow-md`}>
      <QrCode className="text-white" size={size === "sm" ? 18 : size === "lg" ? 26 : 22} strokeWidth={2.4} />
    </div>
  );
}

export function BrandHeader({ rightSlot }) {
  return (
    <div className="flex items-center gap-3 mb-8">
      <BrandMark />
      <Link to="/" className="font-heading font-bold text-2xl tracking-tight text-ink hover:text-brand transition">
        QrTourist
      </Link>
      <div className="flex-1" />
      {rightSlot}
    </div>
  );
}
